import { render, staticRenderFns } from "./timeMenuTemplateManage.vue?vue&type=template&id=566a5eb9&scoped=true"
import script from "./timeMenuTemplateManage.vue?vue&type=script&lang=js"
export * from "./timeMenuTemplateManage.vue?vue&type=script&lang=js"
import style0 from "./timeMenuTemplateManage.vue?vue&type=style&index=0&id=566a5eb9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566a5eb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566a5eb9')) {
      api.createRecord('566a5eb9', component.options)
    } else {
      api.reload('566a5eb9', component.options)
    }
    module.hot.accept("./timeMenuTemplateManage.vue?vue&type=template&id=566a5eb9&scoped=true", function () {
      api.rerender('566a5eb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/menuTemplateManage/timeMenuTemplateManage.vue"
export default component.exports